// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container-editar-empresa {
    width: calc(100% - 1.1rem);
    padding-left: 5.1rem;
    padding-top: 3.9rem;
    display: flex;
    justify-content: center;
    height: max-content;
    gap: 1rem;
}

.container-geral-cadastro-empresa {
    box-shadow: 2px 3px 4px 2px rgba(0, 0, 0, .1);
    border-radius: 8px;
    min-width: max-content;
    max-width: 80%;
}

.formulario-editar-nova-empresa {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 1rem;
    background-color: var(--branco-padrao);
    padding: .7rem 1rem;
    border-radius: 0 0 8px 8px;
}

.container-razao-sigla {
    width: 100%;
    display: flex;
    justify-content: space-between;
    gap: 1rem;
    margin-bottom: 1.3rem;
}

.container-razao-sigla .container-input-padrao.razao-social {
    width: 80%;
}

.container-documentos-cadastro-empresa {
    margin-top: 1.5rem;
}

.titulo-documentos-cadastro-empresa {
    font-size: 1.1rem;
    font-weight: bold;
    color: var(--azul-dixi);
    margin-bottom: .7rem;
}

.container-inputs-selects {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;
    margin-top: .7rem;
}

.container-botoes-confirmar-cancelar-cadastro-empresa {
    display: flex;
    margin-top: 2rem;
    width: 100%;
    align-items: center;
    justify-content: center;
    gap: 2rem;
}

.container-input-select-padrao.tipo-documento {
    min-width: 11.7rem;
}

.container-input-padrao.numero-documento-cad-empresa {
    min-width: 13.5rem;
}`, "",{"version":3,"sources":["webpack://./src/components/FormEditarEmpresa/FormEditarEmpresa.css"],"names":[],"mappings":"AAAA;IACI,0BAA0B;IAC1B,oBAAoB;IACpB,mBAAmB;IACnB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,6CAA6C;IAC7C,kBAAkB;IAClB,sBAAsB;IACtB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,sCAAsC;IACtC,mBAAmB;IACnB,0BAA0B;AAC9B;;AAEA;IACI,WAAW;IACX,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,qBAAqB;AACzB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,uBAAuB;IACvB,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,WAAW;IACX,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB","sourcesContent":[".container-editar-empresa {\n    width: calc(100% - 1.1rem);\n    padding-left: 5.1rem;\n    padding-top: 3.9rem;\n    display: flex;\n    justify-content: center;\n    height: max-content;\n    gap: 1rem;\n}\n\n.container-geral-cadastro-empresa {\n    box-shadow: 2px 3px 4px 2px rgba(0, 0, 0, .1);\n    border-radius: 8px;\n    min-width: max-content;\n    max-width: 80%;\n}\n\n.formulario-editar-nova-empresa {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n    background-color: var(--branco-padrao);\n    padding: .7rem 1rem;\n    border-radius: 0 0 8px 8px;\n}\n\n.container-razao-sigla {\n    width: 100%;\n    display: flex;\n    justify-content: space-between;\n    gap: 1rem;\n    margin-bottom: 1.3rem;\n}\n\n.container-razao-sigla .container-input-padrao.razao-social {\n    width: 80%;\n}\n\n.container-documentos-cadastro-empresa {\n    margin-top: 1.5rem;\n}\n\n.titulo-documentos-cadastro-empresa {\n    font-size: 1.1rem;\n    font-weight: bold;\n    color: var(--azul-dixi);\n    margin-bottom: .7rem;\n}\n\n.container-inputs-selects {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 1rem;\n    margin-top: .7rem;\n}\n\n.container-botoes-confirmar-cancelar-cadastro-empresa {\n    display: flex;\n    margin-top: 2rem;\n    width: 100%;\n    align-items: center;\n    justify-content: center;\n    gap: 2rem;\n}\n\n.container-input-select-padrao.tipo-documento {\n    min-width: 11.7rem;\n}\n\n.container-input-padrao.numero-documento-cad-empresa {\n    min-width: 13.5rem;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
